import { Component, DestroyRef, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';

import { FeaturedEventService } from '../../core/events/featured-event.service';
import { NewsletterSignup } from '../../core/newsletter/newsletter-signup';

// Shared "BIG SALE" newsletter/CTA banner. Both promo links follow the current featured event: its
// coupon page and — when that event has one — its deals page. The event lookup lives in
// FeaturedEventService so the header and this banner cannot drift apart.
//
// The subscribe form posts to the public API; addresses show up in the admin panel under Newsletter
// Subscribers. `NewsletterSignup` is provided here (not root) so this form owns its own state.
//
// Its `.sav-big-sale-*` styles are global (src/styles.scss), so it can be dropped onto any page:
// <app-big-sale-banner />.
@Component({
  selector: 'app-big-sale-banner',
  imports: [RouterLink, ReactiveFormsModule],
  providers: [NewsletterSignup],
  templateUrl: './big-sale-banner.html',
})
export class BigSaleBanner {
  private readonly featuredEvent = inject(FeaturedEventService);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly signup = inject(NewsletterSignup);

  protected readonly featuredEventLabel = signal('');
  protected readonly featuredEventPath = signal('');
  /** Label for the deals link — may name a different event than the coupons link (see the service). */
  protected readonly featuredEventDealsLabel = signal('');
  /** '' when no event has a deals page — the link is then not rendered at all. */
  protected readonly featuredEventDealsPath = signal('');

  constructor() {
    this.featuredEvent
      .featured()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((links) => {
        this.featuredEventLabel.set(links?.couponLabel ?? '');
        this.featuredEventPath.set(links?.couponPath ?? '');
        this.featuredEventDealsLabel.set(links?.dealsLabel ?? '');
        this.featuredEventDealsPath.set(links?.dealsPath ?? '');
      });
  }
}
